import React from 'react';
import { DraggableProvidedDragHandleProps } from 'react-beautiful-dnd';
import { DeliveryMethodSectionHeader } from './DeliveryMethodSectionHeader';

interface DeliveryMethodSectionBlockProps {
  sectionName: string;
  deliveryMethodCountLabel: string;
  isCollapsed: boolean;
  canCollapse: boolean;
  hasNoMatchesUnderFilter: boolean;
  onToggleCollapsed: () => void;
  dragHandleProps?: DraggableProvidedDragHandleProps | null;
  onRenameSection?: (sectionName: string) => void;
  onDeleteSection?: () => void;
  children: React.ReactNode;
}

export const DeliveryMethodSectionBlock = ({
  sectionName,
  deliveryMethodCountLabel,
  isCollapsed,
  canCollapse,
  hasNoMatchesUnderFilter,
  onToggleCollapsed,
  dragHandleProps,
  onRenameSection,
  onDeleteSection,
  children,
}: DeliveryMethodSectionBlockProps) => (
  <>
    <DeliveryMethodSectionHeader
      sectionName={sectionName}
      deliveryMethodCountLabel={deliveryMethodCountLabel}
      isCollapsed={isCollapsed}
      canCollapse={canCollapse}
      onToggleCollapsed={onToggleCollapsed}
      dragHandleProps={dragHandleProps}
      onRenameSection={onRenameSection}
      onDeleteSection={onDeleteSection}
    />
    {!isCollapsed && !hasNoMatchesUnderFilter && children}
  </>
);
